import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

const ROLES = [
  { value: "admin", label: "Administrador" },
  { value: "vendedor", label: "Vendedor" },
  { value: "cliente", label: "Cliente" },
  { value: "pending", label: "Pendiente" },
];

const roleColor = {
  admin: "bg-turquoise/10 text-turquoise border-turquoise/30",
  vendedor: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30",
  cliente: "bg-violet-500/10 text-violet-400 border-violet-500/30",
  pending: "bg-amber-500/10 text-amber-400 border-amber-500/30",
};

export default function Users() {
  const [users, setUsers] = useState([]);
  const [customers, setCustomers] = useState([]);

  const load = async () => {
    const [u, c] = await Promise.all([api.get("/users"), api.get("/customers")]);
    setUsers(u.data);
    setCustomers(c.data);
  };
  useEffect(() => { load(); }, []);

  const updateRole = async (user_id, role, linked_customer_id = null) => {
    try {
      await api.put(`/users/${user_id}/role`, { role, linked_customer_id });
      toast.success("Rol actualizado");
      load();
    } catch (e) { toast.error("Error"); }
  };

  return (
    <div className="p-6 md:p-10" data-testid="users-page">
      <header className="mb-6">
        <p className="text-xs uppercase tracking-[0.3em] text-turquoise font-mono mb-1">Acceso y seguridad</p>
        <h1 className="text-3xl md:text-4xl font-heading font-bold">Usuarios del sistema</h1>
        <p className="text-zinc-400 mt-1 text-sm">Asigna roles y vincula cuentas con clientes</p>
      </header>

      <div className="glass-card rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-[10px] uppercase tracking-wider text-zinc-500 border-b border-white/5">
              <tr>
                <th className="text-left p-4 font-mono">Usuario</th>
                <th className="text-left p-4 font-mono">Email</th>
                <th className="text-left p-4 font-mono">Rol</th>
                <th className="text-left p-4 font-mono">Cliente vinculado</th>
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr><td colSpan="4" className="p-12 text-center text-zinc-500">Sin usuarios</td></tr>
              ) : users.map((u) => (
                <tr key={u.user_id} className="border-b border-white/5 hover:bg-white/[0.02]">
                  <td className="p-4">
                    <div className="flex items-center gap-3">
                      {u.picture ? (
                        <img src={u.picture} alt={u.name} className="w-8 h-8 rounded-full border border-white/10" />
                      ) : (
                        <div className="w-8 h-8 rounded-full bg-brand-gradient flex items-center justify-center text-black font-bold text-xs">
                          {u.name?.[0]}
                        </div>
                      )}
                      <span className="font-medium">{u.name}</span>
                    </div>
                  </td>
                  <td className="p-4 text-zinc-400 font-mono text-xs">{u.email}</td>
                  <td className="p-4">
                    <select
                      value={u.role}
                      onChange={(e) => updateRole(u.user_id, e.target.value, u.role === "cliente" ? u.linked_customer_id : null)}
                      data-testid={`role-select-${u.user_id}`}
                      className={`bg-black/40 border rounded-md px-3 py-1.5 text-xs font-mono uppercase tracking-wider ${roleColor[u.role]}`}
                    >
                      {ROLES.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
                    </select>
                  </td>
                  <td className="p-4">
                    {u.role === "cliente" ? (
                      <select
                        value={u.linked_customer_id || ""}
                        onChange={(e) => updateRole(u.user_id, "cliente", e.target.value || null)}
                        className="bg-black/40 border border-white/10 rounded-md px-3 py-1.5 text-xs"
                      >
                        <option value="">— Vincular cliente —</option>
                        {customers.map((c) => <option key={c.customer_id} value={c.customer_id}>{c.name}</option>)}
                      </select>
                    ) : (
                      <span className="text-zinc-600 text-xs font-mono">—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <p className="text-xs text-zinc-500 mt-4 font-mono">
        Los usuarios nuevos quedan en estado <span className="text-amber-400">PENDIENTE</span> y deben recibir un rol para acceder.
      </p>
    </div>
  );
}
